module.exports = __webpack_public_path__ + "img/142ne.62c92e90.svg";